import { Link } from "react-router-dom";

export const SlimFooter = () => (
  <footer className="border-t border-canvas-line" data-testid="slim-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-8 text-xs text-steel sm:flex-row sm:items-center sm:justify-between sm:px-8">
      <span>© {new Date().getFullYear()} Ramor Renewables Heating &amp; Plumbing Ltd. All rights reserved.</span>
      <div className="flex items-center gap-6">
        <span className="label-mono">RGI · SEAI · OFTEC · F-Gas</span>
        <Link to="/privacy" className="hover:text-ink" data-testid="slim-footer-privacy">Privacy notice</Link>
      </div>
    </div>
  </footer>
);
